export const sharedI18n = {
  shared: {
    en: {
      APPLY: 'Apply',
      CANCEL: 'Cancel',
      DOWNLOAD: 'Download',
      DROP_FILES_HERE: 'Drop files here',
      EMAIL: 'Email',
      ERROR_WHILE_DOWNLOADING: 'Error while downloading',
      EXPORT: 'Export',
      FILTER: 'Filter',
      I_CONFIRM_AND_ACCEPT: 'I confirm and accept',
      INVALID_EMAIL: 'Invalid email',
      LOADING: 'Loading...',
      MESSAGE: 'Message',
      NO_FILTERS: 'There are no filters to show',
      NO_OPTIONS: 'No options',
      NOTHING_TO_SHOW: 'There is nothing to show',
      OK: 'Ok',
      OPERATION_FAILED: 'Operation failed',
      OPERATION_SUCCESSFUL: 'Operation successful',
      RESET: 'Reset',
      SEARCH: 'Search',
      SELECT_DATE_BETWEEN_RANGE: 'Select date between a start and end date',
      SEND: 'Send',
    },
    'sv-SE': {
      APPLY: 'Använd',
      CANCEL: 'Avbryt',
      DOWNLOAD: 'Ladda ner',
      DROP_FILES_HERE: 'Släpp filer här',
      EMAIL: 'E-post',
      ERROR_WHILE_DOWNLOADING: 'Fel vid nedladdning',
      EXPORT: 'Exportera',
      FILTER: 'Filter',
      I_CONFIRM_AND_ACCEPT: 'Jag bekräftar och accepterar',
      INVALID_EMAIL: 'Ogiltig e-post',
      LOADING: 'Laddar...',
      MESSAGE: 'Meddelande',
      NO_FILTERS: 'Det finns inga filter att visa',
      NO_OPTIONS: 'Inga alternativ',
      NOTHING_TO_SHOW: 'Det finns inget att visa',
      OK: 'Ok',
      OPERATION_FAILED: 'Åtgärd misslyckades',
      OPERATION_SUCCESSFUL: 'Åtgärd lyckades',
      RESET: 'Återställ',
      SEARCH: 'Sök',
      SELECT_DATE_BETWEEN_RANGE: 'Välj datum mellan ett start- och slutdatum',
      SEND: 'Skicka',
    },
  },
};
